import React from 'react';

const TRANSMISSION_OPTIONS = [
  { value: 'automatic', label: 'Automático' },
  { value: 'manual', label: 'Manual' },
  { value: 'both', label: 'Tanto faz' },
];

export const QuestionarioCarrosStepThree = ({ formData, handleChange }) => {
  return (
    <div className="space-y-4" data-testid="questionario-carros-step-3">
      <div className="grid grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Ano *</label>
          <select
            name="yearRange"
            value={formData.yearRange}
            onChange={handleChange}
            required
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500"
            data-testid="questionario-carros-year-range-select"
          >
            <option value="">Selecione</option>
            <option value="2023-2025">2023 - 2025</option>
            <option value="2020-2022">2020 - 2022</option>
            <option value="2017-2019">2017 - 2019</option>
            <option value="2014-2016">2014 - 2016</option>
            <option value="anterior-2014">Anterior a 2014</option>
          </select>
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Km Máxima</label>
          <select
            name="maxKm"
            value={formData.maxKm}
            onChange={handleChange}
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500"
            data-testid="questionario-carros-max-km-select"
          >
            <option value="">Sem limite</option>
            <option value="30000">Até 30.000 km</option>
            <option value="50000">Até 50.000 km</option>
            <option value="80000">Até 80.000 km</option>
            <option value="100000">Até 100.000 km</option>
          </select>
        </div>
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Câmbio</label>
        <div className="flex gap-4" data-testid="questionario-carros-transmission-options">
          {TRANSMISSION_OPTIONS.map((option) => (
            <label key={option.value} className="flex items-center gap-2 cursor-pointer" data-testid={`questionario-carros-transmission-option-${option.value}`}>
              <input
                type="radio"
                name="transmission"
                value={option.value}
                checked={formData.transmission === option.value}
                onChange={handleChange}
                className="w-4 h-4 text-orange-600 border-gray-300 focus:ring-orange-500"
                data-testid={`questionario-carros-transmission-radio-${option.value}`}
              />
              <span className="text-gray-700">{option.label}</span>
            </label>
          ))}
        </div>
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Combustível</label>
        <select
          name="fuel"
          value={formData.fuel}
          onChange={handleChange}
          className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500"
          data-testid="questionario-carros-fuel-select"
        >
          <option value="">Sem preferência</option>
          <option value="gasoline">Gasolina</option>
          <option value="hybrid">Híbrido</option>
          <option value="electric">Elétrico</option>
          <option value="diesel">Diesel</option>
        </select>
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Orçamento *</label>
        <select
          name="budget"
          value={formData.budget}
          onChange={handleChange}
          required
          className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500"
          data-testid="questionario-carros-budget-select"
        >
          <option value="">Selecione</option>
          <option value="ate-500k">Até ¥500.000</option>
          <option value="500k-1M">¥500.000 - ¥1.000.000</option>
          <option value="1M-2M">¥1.000.000 - ¥2.000.000</option>
          <option value="2M-3M">¥2.000.000 - ¥3.000.000</option>
          <option value="acima-3M">Acima de ¥3.000.000</option>
        </select>
      </div>
    </div>
  );
};
